<template>
  <div>
    <!-- <h1>客户跟进记录</h1> -->
    <!-- <button @click="addNewRecord">新增记录</button> -->
    <el-descriptions title="学生信息">
    <el-descriptions-item label="姓名">{{student.nickname}}</el-descriptions-item>
    <el-descriptions-item label="年龄">{{student.age}}</el-descriptions-item>
    <el-descriptions-item label="监护人">{{student.real_name}}（{{student.mobile}}）</el-descriptions-item>
    <el-descriptions-item label="备注">
      <el-tag size="small">{{student.remark}}</el-tag>
    </el-descriptions-item>
    <el-descriptions-item label="生日">{{student.birth_date}}</el-descriptions-item>
    <el-descriptions-item label="意向">
      <el-tag size="small" :type="student.intention * 1  == 1 ? '' : 'info'" @click="setIntention(1)">有</el-tag>
      <el-tag size="small" :type="student.intention * 1  == 2 ? '' : 'info'" style="margin-left: 0.5rem;" @click="setIntention(2)">无</el-tag>
    </el-descriptions-item>
</el-descriptions>
    <!-- <button @click="$emit('open-form')">新增记录</button> -->
    <el-button size="mini" type="primary" @click="$emit('open-form')">新增记录</el-button>
    <table>
      <thead>
        <tr>
          <th>客户姓名</th>
          <th>联系电话</th>
          <th>跟进日期</th>
          <th>跟进内容</th>
          <!-- <th>状态</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-if="isAdding">
          <td><input v-model="newRecord.customerName" placeholder="姓名" /></td>
          <td><input v-model="newRecord.mobile" placeholder="电话" /></td>
          <td>
            <el-date-picker
              v-model="newRecord.followDate"
              type="date"
              placeholder="选择日期"
              :clearable="true"
              :default-time="new Date()"
              :size="mini"
            />
          </td>
          <td><input v-model="newRecord.content" placeholder="内容" /></td>
          <!-- <td>
            <select v-model="newRecord.status">
              <option value="已跟进">已跟进</option>
              <option value="待跟进">待跟进</option>
            </select>
          </td> -->
          <td>
            <button @click="submitNewRecord">提交</button>
          </td>
        </tr>
        <tr v-for="record in records" :key="record.id">
          <td>{{ record.customer_name }}</td>
          <td>{{ record.mobile }}</td>
          <td>{{ record.follow_date }}</td>
          <td>{{ record.content }}</td>
          <!-- <td>{{ record.status }}</td> -->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    records: {
      type: Array,
      required: true
    },
    student: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isAdding: false,
      newRecord: {
        customerName: '',
        mobile: '',
        followDate: new Date(), // 默认当前日期
        content: ''
      }
    }
  },
  methods: {
    setIntention (val) {
      this.student.intention = val
      this.$emit('update-value', val)
    }
    /* addNewRecord () {
      this.isAdding = true
    },
    submitNewRecord () {
      const record = {
        id: Date.now(), // 使用时间戳作为唯一 ID
        ...this.newRecord
      }
      this.$emit('add-record', record) // 触发事件，将新记录传递给父组件
      this.resetNewRecord() // 重置表单
      this.isAdding = false // 收起新增行
    },
    resetNewRecord () {
      this.newRecord = {
        customerName: '',
        mobile: '',
        followDate: new Date(), // 默认当前日期
        content: '',
        status: '待跟进'
      }
    } */
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}
th, td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}
th {
  background-color: #f2f2f2;
}
input, select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerFollowUp.vue